import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import { todayIso } from '@/lib/dateUtils';
import { updateCameraDiscount } from '@/models/camera/service';

export function useDiscountModal(reloadServices: () => void) {
  const store = useLocalObservable(() => ({
    isOpen: false,
    idCamera: '',
    cameraName: '',
    abPlata: '',
    discount: '',
    date: '',
    comments: '',
    isLoading: false,
    error: null as string | null,
  }));

  function open(idCamera: string, cameraName: string, currentDiscount: string, abPlata: string) {
    runInAction(() => {
      store.isOpen = true;
      store.idCamera = idCamera;
      store.cameraName = cameraName;
      store.abPlata = abPlata;
      store.discount = currentDiscount === '0' ? '' : currentDiscount;
      store.date = todayIso();
      store.comments = '';
      store.error = null;
    });
  }

  function close() {
    runInAction(() => {
      store.isOpen = false;
    });
  }

  function setDiscount(value: string) {
    runInAction(() => {
      store.discount = value;
    });
  }

  function setDate(value: string) {
    runInAction(() => {
      store.date = value;
    });
  }

  function setComments(value: string) {
    runInAction(() => {
      store.comments = value;
    });
  }

  function submit() {
    runInAction(() => {
      store.isLoading = true;
      store.error = null;
    });
    updateCameraDiscount(store.idCamera, {
      discount: store.discount || '0',
      date: store.date || undefined,
      comments: store.comments || undefined,
    })
      .then(() => {
        runInAction(() => {
          store.isOpen = false;
          store.isLoading = false;
        });
        reloadServices();
      })
      .catch((err: Error) =>
        runInAction(() => {
          store.error = err.message;
          store.isLoading = false;
        })
      );
  }

  return {
    get isOpen() {
      return store.isOpen;
    },
    get idCamera() {
      return store.idCamera;
    },
    get cameraName() {
      return store.cameraName;
    },
    get abPlata() {
      return store.abPlata;
    },
    get discount() {
      return store.discount;
    },
    get date() {
      return store.date;
    },
    get comments() {
      return store.comments;
    },
    get isLoading() {
      return store.isLoading;
    },
    get error() {
      return store.error;
    },
    open,
    close,
    setDiscount,
    setDate,
    setComments,
    submit,
  };
}

export type DiscountModal = ReturnType<typeof useDiscountModal>;
